import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DropdownList from "shared/components/DropdownList";

export const StyledUser = styled(Box)`
  display: flex;
  align-items: center;
  margin: 0 1.5rem 1.5rem;
`;

export const StyledIconContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor",
})<{ bgColor: string }>`
  margin-right: 1rem;
  width: 48px;
  min-width: 48px;
  height: 48px;
  background-color: ${({ bgColor }: { bgColor?: string }) =>
    bgColor || "#F6F8FA"};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
`;

export const StyledTitleContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
`;

export const StyledText = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const StyledDropdownList = styled(DropdownList)`
  margin-left: 0.25rem;

  & .MuiMenu-paper {
    margin-top: -0.5rem;
  }
`;
